import PageInfo from './PageInfo'
import Pager from './Pager'
import DropdownControl from '../dropdown/DropdownControl'
import PageSizeSelector from './PageSizeSelector'
import ButtonControl from '../button-control/index'
import Icon from '../assets/index'

export const calculateTotalPages = (total, pageSize) => Math.ceil(total / pageSize)

const Pagination = ({ currentPage, total, pageSize, pageSizes, onPageChange, onPageSizeChange, displayListUpwards }) => {
  const totalPages = calculateTotalPages(total, pageSize)

  return (
    <div class='control-pagination'>
      <Pager isDisabled={currentPage === 1} onClick={() => onPageChange(1)}><a>First</a></Pager>
      <Pager isDisabled={currentPage === 1} isChevron onClick={() => onPageChange(currentPage - 1)}><Icon icon={'chevronLeft'} /></Pager>
      <PageInfo currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
      <Pager isDisabled={currentPage === totalPages} isChevron onClick={() => onPageChange(currentPage + 1)}><Icon icon={'chevronRight'} /></Pager>
      <Pager isDisabled={currentPage === totalPages} onClick={() => onPageChange(totalPages)}><a>Last</a></Pager>
      <DropdownControl
        displayListUpwards={displayListUpwards}
        align={'adjust'}
        trigger={<ButtonControl title={`${pageSize} rows`} class={'control-pagination--page-selector'} icon={'arrowDropdown'} />}
        items={PageSizeSelector(pageSizes, onPageSizeChange)}
      />
    </div>
  )
}

export default Pagination
